import { ReactNode } from 'react';

const TONE = {
  up: 'bg-success-bg text-success',
  down: 'bg-danger-bg text-danger-ink',
  // Design `.c-none`.
  neutral: 'bg-ground text-muted',
  // Design `.c-mute`.
  mute: 'bg-ground text-muted-2',
  accent: 'bg-accent-bg text-accent-ink',
  // Design `.st-i` (in progress / a status the case moved to).
  info: 'bg-mist text-muted-2',
  // Design `.p-warn` on a mono chip.
  warn: 'bg-warning-bg text-warning-ink',
} as const;

export default function Chip({ tone, children }: { tone: keyof typeof TONE; children: ReactNode }) {
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-[3px] font-mono text-xs font-semibold ${TONE[tone]}`}>{children}</span>;
}
